"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typography = {
    large: {
        mini: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 12,
            lineHeight: 16,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        miniBold: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 12,
            lineHeight: 16,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        caption: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 14,
            lineHeight: 16,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        captionBold: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 14,
            lineHeight: 16,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        body: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 16,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        bodyBold: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 16,
            lineHeight: 24,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        lead: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 18,
            lineHeight: 28,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        overline: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 14,
            lineHeight: 16,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
        },
        displaySmall: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 18,
            lineHeight: 28,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        subheading: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 20,
            lineHeight: 24,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        displayMedium: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 24,
            lineHeight: 30,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        heading: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 31,
            lineHeight: 32,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        pageheading: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 39,
            lineHeight: 48,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        displayLarge: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 48,
            lineHeight: 54,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        callout: {
            font: 'Georgia, serif',
            size: 18,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        code: {
            font: 'monospace',
            size: 18,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
    },
    regular: {
        mini: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 12,
            lineHeight: 20,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        miniBold: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 12,
            lineHeight: 20,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        caption: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 14,
            lineHeight: 20,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        captionBold: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 14,
            lineHeight: 20,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        body: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 16,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        bodyBold: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 16,
            lineHeight: 24,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        lead: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 18,
            lineHeight: 32,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        overline: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 14,
            lineHeight: 20,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
        },
        displaySmall: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 18,
            lineHeight: 32,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        subheading: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 19,
            lineHeight: 24,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        displayMedium: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 23,
            lineHeight: 32,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        heading: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 28,
            lineHeight: 36,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        pageheading: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 33,
            lineHeight: 44,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        displayLarge: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 40,
            lineHeight: 48,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        callout: {
            font: 'Georgia',
            size: 18,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        code: {
            font: 'monospace',
            size: 18,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
    },
    compact: {
        mini: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 12,
            lineHeight: 20,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        miniBold: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 12,
            lineHeight: 20,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        caption: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 14,
            lineHeight: 20,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        captionBold: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 14,
            lineHeight: 20,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        body: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 16,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        bodyBold: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 16,
            lineHeight: 24,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        lead: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 18,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        overline: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 14,
            lineHeight: 20,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
        },
        displaySmall: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 18,
            lineHeight: 24,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        subheading: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 18,
            lineHeight: 24,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        displayMedium: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 20,
            lineHeight: 24,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        heading: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 23,
            lineHeight: 28,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        pageheading: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 26,
            lineHeight: 32,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        displayLarge: {
            font: `AvenirNextLTPro, sans-serif`,
            size: 32,
            lineHeight: 36,
            weight: 700,
            letterSpacing: 0,
            textTransform: 'none',
        },
        callout: {
            font: 'Georgia',
            size: 18,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
        code: {
            font: 'monospace',
            size: 18,
            lineHeight: 24,
            weight: 400,
            letterSpacing: 0,
            textTransform: 'none',
        },
    },
};
exports.default = typography;
//# sourceMappingURL=typography.js.map